import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import "./index.css";

// Defaults do react-query pro app. staleTime 30s serve o caso comum (navegar
// pra detalhe e voltar sem refetch); gcTime mantém o cache 5min; retry: 1
// evita martelar o Worker num erro transitório. refetchOnWindowFocus off
// porque as telas do NOC ficam abertas por horas — não queremos refetch a
// cada alt-tab.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
